<div class="row-container border"
     [class.dark-mode]="darkMode()"
     [style.width.px]="stepperWidth()">
  <button class="action-button right-border" appFocusRemove
          [style.width.px]="size()"
          [style.height.px]="size() + 2"
          [class.dark-mode-disabled]="displayOnly() || value() <= min() || disabled() || !maxValue"
          (click)="decrease()">
    <app-image-loading alt="減少" i18n-alt
                       [src]="displayOnly() || value() <= min() || disabled() || !maxValue
                       ? 'assets/icon_minus_disabled.svg' : 'assets/icon_minus.svg'"
                       [clickable]="true"
                       [selectable]="false"
                       [targetWidth]="actionImageSize()"
                       [targetHeight]="actionImageSize()"/>
  </button>
  @if (!displayOnly()) {
    <ng-container *ngIf="allowSelect; else readonly">
      @if (mobile) {
        <button class="count"
                appFocusRemove
                [class.light]="disabled() || !maxValue"
                [class.dark-mode-disabled]="disabled() || !maxValue"
                [style.height.px]="btnSize()"
                [disabled]="disabled()"
                (click)="numberPicker()">
          {{(disabled() || !value()) ? '' : value()}}
        </button>
      } @else {
        <button class="count"
                appFocusRemove
                [matMenuTriggerFor]="maxValue ? numMenu : null"
                [class.light]="disabled() || !maxValue"
                [style.height.px]="btnSize()"
                [disabled]="disabled()"
                (menuOpened)="lockPage()"
                (menuClosed)="releasePage()">
          {{(disabled() || !value()) ? '' : value()}}
        </button>
        <mat-menu #numMenu="matMenu" class="stepper-panel">
          <button mat-menu-item appFocusRemove
                  *ngFor="let opt of maxValue | newArray: 1"
                  (click)="setCount(opt)">
            <span class="font">{{opt}}</span>
          </button>
        </mat-menu>
      }
    </ng-container>
    <ng-template #readonly>
      <span class="count light">{{((disabled() && !displayOnly()) || !value()) ? '' : value()}}</span>
    </ng-template>
  } @else {
    <span class="count" [class.count-disabled]="disabled()">{{current()}}</span>
  }
  <button class="action-button left-border" appFocusRemove
          [style.width.px]="size()"
          [style.height.px]="size() + 2"
          [class.dark-mode-disabled]="displayOnly() || value() >= maxValue || disabled() || !maxValue"
          (click)="increase()">
    <app-image-loading alt="增加" i18n-alt
                       [src]="displayOnly() || value() >= maxValue || disabled() || !maxValue
                       ? 'assets/icon_plus_disabled.svg' : 'assets/icon_plus.svg'"
                       [clickable]="true"
                       [selectable]="false"
                       [targetWidth]="actionImageSize()"
                       [targetHeight]="actionImageSize()"/>
  </button>
</div>
